import { withTranslate } from "@pathwright/ui/src/components/"
import Gate from "@pathwright/ui/src/components/gate/Gate"
import Gates from "@pathwright/ui/src/components/gate/Gates"
import SignUpOrIn from "@pathwright/web/src/modules/auth/SignUpOrIn"
import {
  SIGNED_IN,
  SIGN_IN,
  SIGN_UP
} from "@pathwright/web/src/modules/auth/constants"
import { OrderSubscriptionFlow } from "@pathwright/web/src/modules/order/OrderSubscriptionCard"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import { ENROLLMENT_ROLE_TEACHER } from "invitation/constants"
import { ConnectStores } from "lib/core/store"
import { OFFERING_OPTION_IN_PLAN } from "library/register/constants"
import get from "lodash/get"
import lowerFirst from "lodash/lowerFirst"
import { useRef } from "react"
import SignedInFooter from "./SignedInFooter"

const RegisterAuthGateOld = ({
  register,
  requiresSubscription,
  offering,
  resource,
  unlockMessage,
  invitation,
  sso,
  truncatedSchoolName,
  promo,
  t
}) => {
  const { me, school } = usePathwrightContext()
  const initiallyAuthenticated = useRef(!!me).current

  const signUpOrInProps = {
    hideSignOut: !initiallyAuthenticated,
    providedEmail: (invitation && invitation.extra.to_email) || null,
    providedFirstName: (invitation && invitation.extra.first_name) || null,
    providedLastName: (invitation && invitation.extra.last_name) || null,
    renderSubmit: ({ submit, view }) =>
      view === SIGNED_IN ? <SignedInFooter /> : submit
  }

  const SignInGate = () => <SignUpOrIn {...signUpOrInProps} view={SIGN_IN} />

  const SignUpGate = () => <SignUpOrIn {...signUpOrInProps} view={SIGN_UP} />

  const SubscribeGate = () => (
    <OrderSubscriptionFlow
      planIds={offering.include_in_subscription_plans}
      productIds={offering.include_with_products}
      redirectTo={window.location.pathname + window.location.search}
    />
  )

  // For whatever reason, getting unexpected React error
  // Unhandled rejection Invariant Violation: Element type is invalid: expected a string
  // when trying to use Pathicon
  const heading = null // Removed on 1.25.21 as unnecessary
  // const heading = (
  //   <p>
  //     <Pathicon icon="lock" /> {unlockMessage}
  //   </p>
  // )

  if (
    initiallyAuthenticated ||
    (invitation && invitation.offering_registration) ||
    !sso.pathwright_login_enabled
  ) {
    return <SignUpOrIn {...signUpOrInProps} view={SIGN_IN} />
  }

  if (requiresSubscription) {
    return (
      <Gates className="RegisterAuthGate" heading={heading}>
        <Gate
          line1={t("registration.auth_gate.have_subscription")}
          line2={t("registration.auth_gate.sign_in")}
          gate={<SignUpOrIn {...signUpOrInProps} view={SIGN_IN} />}
        />
        <Gate
          line1={t("registration.auth_gate.no_subscription")}
          line2={t("registration.auth_gate.create_a_subscription", {
            school_name: school.name
          })}
          gate={SubscribeGate}
        />
      </Gates>
    )
  }

  return (
    <Gates className="RegisterAuthGate" heading={heading}>
      {get(sso, "providers.length") > 0 ? (
        <Gate
          line1={sso.providers
            .map((p) => p.label)
            .join(` ${t("registration.auth_gate.or")} `)}
          line2={`
              ${t("registration.auth_gate.use_existing")}${" "}
              ${truncatedSchoolName}${" "}
              ${t("registration.auth_gate.account_to_sign_in")}${" "}
              ${t("registration.auth_gate.or")}${" "}
              ${sso.providers
                .map((p) => lowerFirst(p.label))
                .join(` ${t("registration.auth_gate.or")} `)}.`}
          gate={SignInGate}
        />
      ) : (
        <Gate
          line1={t("registration.auth_gate.i_have_account")}
          line2={t("registration.auth_gate.sign_in_to_proceed")}
          gate={SignInGate}
        />
      )}
      <Gate
        line1={t("registration.auth_gate.dont_have_account")}
        line2={t("registration.auth_gate.create_an_account", {
          school_name: truncatedSchoolName
        })}
        gate={SignUpGate}
      />
    </Gates>
  )
}

RegisterAuthGateOld.displayName = "RegisterAuthGateOld"

const mapStateToProps = (state, ownProps) => {
  const { t } = ownProps

  let unlockMessage
  const { offering_option, offering, resource, invitation } =
    state.registerStore.state
  const { register } = state.registerStore.action
  const { school, integrations } = state.schoolStore.state

  const requiresSubscription =
    offering_option === OFFERING_OPTION_IN_PLAN &&
    !(invitation && invitation.role === ENROLLMENT_ROLE_TEACHER)

  if (invitation != null ? invitation.offering_registration : undefined) {
    unlockMessage = `${t("registration.auth_gate.only_for")} ${
      invitation.offering_registration.user.email
    }`
  } else if (requiresSubscription) {
    unlockMessage = t("registration.auth_gate.only_for_subscribers")
  } else {
    unlockMessage = t("registration.auth_gate.only_for_members")
  }

  const truncatedSchoolName = state.schoolStore.request.truncatedName()

  return _.assign(
    {},
    {
      register,
      offering,
      resource,
      unlockMessage,
      requiresSubscription,
      invitation,
      sso: integrations.sso,
      truncatedSchoolName
    },
    ownProps
  )
}

const stores = [
  { store: "register", watch: ["invitation"] },
  { store: "school", watch: false }
]

export default withTranslate(
  ConnectStores(RegisterAuthGateOld, stores, {}, mapStateToProps)
)
